export default "__VITE_PUBLIC_ASSET__cb98c012__"